'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactRedux = require('react-redux');

var _reactRhumb = require('react-rhumb');

var _staticAdapter = require('react-rhumb/staticAdapter');

var _staticAdapter2 = _interopRequireDefault(_staticAdapter);

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _hubspotUrlinator = require('hubspot.urlinator.Url');

var _hubspotUrlinator2 = _interopRequireDefault(_hubspotUrlinator);

var _handlers = require('q/js/handlers');

var _rhumbConfig = require('../rhumb-config.yaml');

var _rhumbConfig2 = _interopRequireDefault(_rhumbConfig);

var _AsyncData = require('conversations-async-data/async-data/AsyncData');

var _AsyncData2 = _interopRequireDefault(_AsyncData);

var _WidgetData = require('conversations-schema/records/WidgetData');

var _WidgetData2 = _interopRequireDefault(_WidgetData);

var _makeUsageTracker = require('./usage-tracking/factories/makeUsageTracker');

var _buildStore = require('./buildStore');

var _buildStore2 = _interopRequireDefault(_buildStore);

var _ApplicationContainer = require('./containers/ApplicationContainer');

var _ApplicationContainer2 = _interopRequireDefault(_ApplicationContainer);

var _AsyncMessagesPreview = require('./code-splitting/components/AsyncMessagesPreview');

var _AsyncMessagesPreview2 = _interopRequireDefault(_AsyncMessagesPreview);

var _ErrorBoundary = require('./components/ErrorBoundary');

var _ErrorBoundary2 = _interopRequireDefault(_ErrorBoundary);

var _WidgetUi = require('./widget-ui/records/WidgetUi');

var _WidgetUi2 = _interopRequireDefault(_WidgetUi);

var _VisitorIdentity = require('./visitor-identity/records/VisitorIdentity');

var _VisitorIdentity2 = _interopRequireDefault(_VisitorIdentity);

var _SpeedCurveWidgetData = require('./widget-modes/constants/SpeedCurveWidgetData');

var _WidgetModes = require('./constants/WidgetModes');

var _parseStringBoolean = require('./utils/parseStringBoolean');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Application = function () {
  function Application() {
    _classCallCheck(this, Application);

    this.widgetShellUrl = new _hubspotUrlinator2.default(window.location);
  }

  _createClass(Application, [{
    key: 'getQueryParam',
    value: function getQueryParam(param) {
      return this.widgetShellUrl.paramValue(param);
    }
  }, {
    key: 'getMessagesUtk',
    value: function getMessagesUtk() {
      var path = this.widgetShellUrl.pathname;

      var utkIndex = path.indexOf('/utk/');

      var messagesUtkPathValue = path.slice(utkIndex).split('/').pop();

      var shouldUsePathValue = messagesUtkPathValue !== 'null' && utkIndex !== -1;

      return shouldUsePathValue ? messagesUtkPathValue : this.getQueryParam('messagesUtk');
    }
  }, {
    key: 'getUrl',
    value: function getUrl() {
      var urlParam = this.getQueryParam('url');

      try {
        return decodeURIComponent(urlParam);
      } catch (error) {
        return urlParam;
      }
    }
  }, {
    key: 'getSpeedCurveWidgetData',
    value: function getSpeedCurveWidgetData() {
      var widgetUi = {
        mobile: this.getQueryParam('mobile') === 'true',
        open: this.getQueryParam('open') === 'true'
      };

      return (0, _SpeedCurveWidgetData.buildSpeedCurveWidgetData)(widgetUi);
    }
  }, {
    key: 'startRedux',
    value: function startRedux() {
      var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var messagesUtk = this.getMessagesUtk();
      var startOpen = (0, _parseStringBoolean.parseStringBoolean)(this.getQueryParam('startOpen'));
      var isEmbeddedInProduct = this.getQueryParam('inApp53') === 'true';

      var defaultStore = _extends({}, initialState, {
        tracker: (0, _makeUsageTracker.makeUsageTracker)({
          messagesUtk: messagesUtk,
          inApp53: isEmbeddedInProduct
        }),
        iframeUuid: this.getQueryParam('uuid'),
        visitorIdentity: new _VisitorIdentity2.default({
          messagesUtk: messagesUtk,
          hubspotUtk: this.getQueryParam('hubspotUtk'),
          isFirstVisitorSession: this.getQueryParam('isFirstVisitorSession') === 'true'
        }),
        widgetUi: (0, _WidgetUi2.default)({
          mobile: this.getQueryParam('mobile') === 'true',
          startOpen: startOpen,
          hideWelcomeMessage: this.getQueryParam('hideWelcomeMessage') !== 'true',
          domain: this.getQueryParam('domain'),
          url: this.getUrl(),
          isEmbeddedInProduct: isEmbeddedInProduct,
          mode: this.getQueryParam('mode')
        })
      });

      this.store = (0, _buildStore2.default)(defaultStore);
    }
  }, {
    key: 'renderWidget',
    value: function renderWidget() {
      this.startRedux();

      var inline = this.getQueryParam('inline') === 'true';

      (0, _reactDom.render)(_react2.default.createElement(
        _ErrorBoundary2.default,
        { errorLoggingTitle: 'visitor-widget' },
        _react2.default.createElement(
          _reactRedux.Provider,
          { store: this.store },
          _react2.default.createElement(
            _reactRhumb.RhumbProvider,
            { history: (0, _staticAdapter2.default)('/'), config: _rhumbConfig2.default },
            _react2.default.createElement(_ApplicationContainer2.default, { location: window.location, inline: inline })
          )
        )
      ), document.getElementsByClassName('widget')[0]);
    }
  }, {
    key: 'renderSpeedCurveWidget',
    value: function renderSpeedCurveWidget() {
      var speedCurveWidgetData = this.getSpeedCurveWidgetData();

      this.startRedux({
        widgetData: new _AsyncData2.default({ data: new _WidgetData2.default(speedCurveWidgetData) })
      });

      var inline = this.getQueryParam('inline') === 'true';

      (0, _reactDom.render)(_react2.default.createElement(
        _reactRedux.Provider,
        { store: this.store },
        _react2.default.createElement(
          _reactRhumb.RhumbProvider,
          { history: (0, _staticAdapter2.default)('/'), config: _rhumbConfig2.default },
          _react2.default.createElement(_ApplicationContainer2.default, {
            location: window.location,
            inline: inline,
            speedCurveWidgetData: speedCurveWidgetData
          })
        )
      ), document.getElementsByClassName('widget')[0]);
    }
  }, {
    key: 'renderPreview',
    value: function renderPreview() {
      this.startRedux();

      (0, _reactDom.render)(_react2.default.createElement(
        _ErrorBoundary2.default,
        { errorLoggingTitle: 'message-preview' },
        _react2.default.createElement(
          _reactRedux.Provider,
          { store: this.store },
          _react2.default.createElement(_AsyncMessagesPreview2.default, {
            location: window.location,
            messageId: this.getQueryParam('messageId'),
            messagesUtk: this.getMessagesUtk()
          })
        )
      ), document.getElementsByClassName('widget')[0]);
    }
  }, {
    key: 'start',
    value: function start() {
      window.AppInstance = this;
      (0, _handlers.logQPromiseIssuesAndSendAlerts)();
      _hubspot2.default.get();

      switch (this.getQueryParam('mode')) {
        case _WidgetModes.SPEED_CURVE:
          this.renderSpeedCurveWidget();
          return;

        case _WidgetModes.PREVIEW:
          this.renderPreview();
          return;

        case _WidgetModes.STANDARD:
        default:
          this.renderWidget();
          return;
      }
    }
  }]);

  return Application;
}();

exports.default = Application;


var app = new Application();

app.start();
module.exports = exports['default'];